module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <ol class=\"breadcrumb\">\r\n      <h2>Voting Calendar</h2>\r\n      <li class=\"active\"><a href=\"#\">Calendar</a></li>\r\n    </ol>\r\n\r\n    <div class=\"col-xs-12\">\r\n      <div id=\"fullCalendar\" ui-calendar=\"ctrl.uiConfig.calendar\" class=\"span8 calendar\" ng-model=\"ctrl.eventSources\"></div>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/calendar/calendar.html
// module id = 526
// module chunks = 0